import Arquivo from '../arquivo/Arquivo.react.js';
import PropTypes from 'prop-types';
import React from 'react';

const getLegendaArquivo = publicacao => publicacao.get('tipoPublicacao');

export const LicitacaoDetalhePublicacao = ({ publicacoes, onDownload }) => (
  <Arquivo
    arquivos={publicacoes}
    onDownload={onDownload}
    getLegendaArquivo={getLegendaArquivo}
    emptyText="Não há publicações."
    tituloVisualizacao="Publicações"
  >
    <Arquivo.Coluna
      id="orgaoPublicacao"
      titulo="Órgão Publicação"
      valor={publicacao => publicacao.get('orgaoPublicacao')}
    />
    <Arquivo.Coluna
      id="tipoPublicacao"
      titulo="Tipo Publicação"
      valor={publicacao => publicacao.get('tipoPublicacao')}
    />
  </Arquivo>
);

LicitacaoDetalhePublicacao.propTypes = {
  publicacoes: PropTypes.object.isRequired,
  onDownload: PropTypes.func.isRequired
};

export default LicitacaoDetalhePublicacao;
